import MuiButton from "@mui/material/Button";
interface ComponentProps {
	children: JSX.Element[] | JSX.Element | string;
	onClick?: (e: any) => void;
	[key: string]: any;
	type?: "submit" | "button" | "reset" | undefined;
}
export default function Button(props: ComponentProps) {
	const { children, onClick, type } = props;
	return (
		<MuiButton
			sx={{
				backgroundColor: "var(--main)",
				mt: 3,
			}}
			variant="contained"
			onClick={onClick}
			type={type}
		>
			{children}
		</MuiButton>
	);
}
